import { render, staticRenderFns } from "./CampanhaTitulo.vue?vue&type=template&id=e3ac9122&"
import script from "./CampanhaTitulo.vue?vue&type=script&lang=js&"
export * from "./CampanhaTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports